export const getImageUrl = (path) => {
  if (!path || typeof path !== "string") return null;

  // If it's already an absolute URL (S3, CDN, etc.), return as-is
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }

  // Example: "http://localhost:5000/api"
  const base = import.meta.env.VITE_API_BASE_URL;

  // remove trailing /api → "http://localhost:5000"
  const backendBase = base.replace(/\/api\/?$/, "");

  // ensure path begins with "/"
  const cleanPath = path.startsWith("/") ? path : `/${path}`;

  return backendBase + cleanPath;
};